import ShortTermProvider from "../provider/ShortTermProvider";
import {
  SET_DATA_FORECAST,
  SET_URL_EXPORT,
  SET_LOADING_APPLY_FORECAST,
  SET_DATA_SORT_TERM,
  SET_DATA_SORT_TERM_RESULT,
  SET_DATA_SORT_TERM_RESULT_ENDOGENIZE,
} from "./ShortTermMutationTypes";
import apolloClient from "@/apollo";

export default {
  state: {
    resultShortTerm: [],
    urlExportShortTerm: "",
    loadingApplyShortTerm: false,
    shortTermData: "[]",
    shortTermDataResult: "[]",
    shortTermDataResultEndogenize: "[]",
  },
  getters: {
    getShortTermResult(state) {
      return state.resultShortTerm;
    },
    getUrlExportShortTerm(state) {
      return state.urlExportShortTerm;
    },
    getLoadingApplyShortTerm(state) {
      return state.loadingApplyShortTerm;
    },
    getDataShortTerm(state) {
      return state.shortTermData;
    },
    getDataShortTermResult(state) {
      return state.shortTermDataResult;
    },
    getDataShortTermResultEndogenize(state) {
      return state.shortTermDataResultEndogenize;
    },
  },
  actions: {
    appleyShortTerm({ commit }, payload) {
      commit(SET_LOADING_APPLY_FORECAST, true);
      apolloClient.cache.reset();
      commit(SET_DATA_FORECAST, []);
      ShortTermProvider.ApplyForecast(payload)
        .then((data) => {
          commit(
            SET_DATA_FORECAST,
            data.data.shortTerm.data.replaceAll("\\", "")
          );
          commit(SET_LOADING_APPLY_FORECAST, false);
        })
        .catch((error) => {
          console.log(error);
          commit(SET_LOADING_APPLY_FORECAST, false);
        });
    },
    exportExcelShortTerm({ commit }, payload) {
      commit(SET_URL_EXPORT, "");
      ShortTermProvider.ApplyExportExcel(
        payload.headers,
        payload.data,
        payload.headers2,
        payload.data2
      ).then((data) => {
        commit(SET_URL_EXPORT, data.data.exportExcel.url);
      });
    },
    setDataShortTerm({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_SORT_TERM, "[]");
      ShortTermProvider.getData(country).then((data) => {
        commit(
          SET_DATA_SORT_TERM,
          data.data.shortTerm.data.replaceAll("\\", "")
        );
      });
    },
    setDataShortTermResult({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_SORT_TERM, "[]");
      ShortTermProvider.getDataResult(country).then((data) => {
        commit(
          SET_DATA_SORT_TERM_RESULT,
          data.data.shockSimulatorResult.data.replaceAll("\\", "")
        );
      });
    },

    setDataShortTermResultEndogenize({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_SORT_TERM_RESULT_ENDOGENIZE, "[]");
      ShortTermProvider.getDataResultEndogenize(country).then((data) => {
        commit(
          SET_DATA_SORT_TERM_RESULT_ENDOGENIZE,
          data.data.shockSimulatorResultEndogenize.data.replaceAll("\\", "")
        );
      });
    },
  },
  mutations: {
    [SET_DATA_FORECAST](state, payload) {
      state.resultShortTerm = payload;
    },
    [SET_URL_EXPORT](state, payload) {
      state.urlExportShortTerm = payload;
    },
    [SET_LOADING_APPLY_FORECAST](state, payload) {
      state.loadingApplyShortTerm = payload;
    },
    [SET_DATA_SORT_TERM](state, payload) {
      state.shortTermData = payload;
    },
    [SET_DATA_SORT_TERM_RESULT](state, payload) {
      state.shortTermDataResult = payload;
    },
    [SET_DATA_SORT_TERM_RESULT_ENDOGENIZE](state, payload) {
      state.shortTermDataResultEndogenize = payload;
    },
  },
};
